<script lang="ts">
    import { Button, Icon } from 'svelte-materialify';
    import { AppBar, Tabs, Tab, Window, WindowItem } from 'svelte-materialify/src';
    import { user } from './stores';
    import Home from './tabs/Home.svelte';
    import Requests from './tabs/Requests.svelte';
    import Meetings from './tabs/Meetings.svelte';
    import Tracing from './tabs/Tracing.svelte';
    import Members from './tabs/Members.svelte';
    import firebase, { googleAuthProvider } from './firebase';
    import { isUserAdmin } from './util';

    $: tabs = Object.assign({
        Home,
    }, $user == null ? {} : {
        Requests,
        Meetings
    }, $user != null && isUserAdmin($user) ? {
        Tracing,
        Members
    } : {});

    let currentTab = 0;
</script>

{#key tabs}
<AppBar>
    <span slot="title" style="display: flex; align-items: center">
        <img src="/arc.png" width="28" alt="Andover Robotics Club">&nbsp;
        ARC Attendance Management System
    </span>
    <div style="flex-grow: 1"></div>

    {#if $user == null}
        <Button text on:click={() => firebase.auth().signInWithPopup(googleAuthProvider())}>
            Sign In
        </Button>
    {:else}
        <div>
            {#if isUserAdmin($user)}
                <Icon class="material-icons">star</Icon>
            {/if}
            <span>{firebase.auth().currentUser.displayName}</span>&nbsp;
            <Button icon on:click={() => { currentTab = [0]; firebase.auth().signOut()}}>
                <span class="material-icons">login</span>
            </Button>
        </div>
    {/if}
    <div slot="extension">
        <Tabs bind:value={currentTab}>
            <div slot="tabs">
                {#each Object.keys(tabs) as tab}
                    <Tab>{tab}</Tab>
                {/each}
            </div>
        </Tabs>
    </div>
</AppBar>
    <Window value={currentTab}>
        {#each Object.values(tabs) as component}
            <WindowItem>
                <svelte:component this={component} />
            </WindowItem>
        {/each}
    </Window>
{/key}